export const stateGame = {
  OFF: "off",
  IN_GAME: "in-game",
  PAUSE: "pause",
  GAME_OVER: "game-over",
};
